import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Select } from 'components/fields'

export default class PersonRoleFields extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    values: PropTypes.object,
    roleTypes: PropTypes.array.isRequired,
    dropdownOrganizations: PropTypes.array.isRequired,
    fetchOrganizationContactAllowedRoles: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired
  }

  render() {
    const { dropdownOrganizations, roleTypes, values, disabled } = this.props

    return (
      <div className="row">
        <div className="col-xs-6">
          <Select
            label="Organization"
            disabled={disabled}
            intlKey="label.organization"
            name="organizationId"
            options={dropdownOrganizations}
            searchable
            clearable={false}
            onSelectChange={obj => {
              this.props.change('organizationContactRoleType.value', null)
              this.props.fetchOrganizationContactAllowedRoles(obj.value)
            }}
          />
        </div>
        <div className="col-xs-6">
          <Select
            label="Role"
            intlKey="label.role"
            name="organizationContactRoleType.value"
            options={roleTypes}
            disabled={!get(values, 'organizationId') || disabled}
          />
        </div>
      </div>
    )
  }
}
